var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 303,
    viewBox: "0 0 1280 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_5684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7 219.5C120.322 155.145 208.04 136.342 361.5 127.276C518.5 118 663.308 167.057 817 178C971.5 189 1102.93 149.894 1282 64M-7 229.5C120.322 165.145 208.04 146.342 361.5 137.276C518.5 128 666.635 191.158 820 206C959.5 219.5 1107.43 207.894 1286.5 122M-7 239.499C120.322 175.144 208.04 156.341 361.5 147.275C518.5 137.999 658.859 209.042 810 238.999C921 261 1107.93 268.393 1287 182.499M-7 249.498C120.322 185.143 208.04 166.341 361.5 157.274C518.5 147.998 636.259 234.256 784 278C873.5 304.5 1100 327 1284 248.998M-7 209.5C120.322 145.145 208.04 126.342 361.5 117.276C518.5 108 662.919 150.5 817 150.5C1037 150.5 1103.43 85.8939 1282.5 0",
    stroke: "#89A5C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_5684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 303,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWave);
export default __webpack_public_path__ + "static/media/about-wave.d7c28be3d0bbdd62e39b1273287c15c2.svg";
export { ForwardRef as ReactComponent };